import { $$, BREAKPOINTS, sleep } from '../_utils'
import EventBus from '../_event-bus'

const WAIT_THRESHOLD = 100

class MatchHeight {
  /**
   * Handles events that may cause match heights to change
   *
   */
  static addResizeListeners = $$matchHeightElements => {
    EventBus.$on('resize', () => {
      this.initEqualHeight($$matchHeightElements)
    })
  }

  /**
   * Calculates the height for each match height group
   *
   */
  static calculateGroupHeights = ({ $$matchHeightElements, groupHeights = {} }) => {
    const newGroupHeights = Object.keys(groupHeights).reduce(
      (acc, key) => ({ ...acc, [key]: 0 }),
      {}
    )
    $$matchHeightElements.forEach($element => {
      $element.style.height = 'auto'
      $element.style.minHeight = 'auto'
      const elementOffset = $element.getBoundingClientRect().top
      const matchHeightGroup = $element.getAttribute('data-match-height')
      const key = `${matchHeightGroup}-${elementOffset}`
      $element.setAttribute('data-match-height-row', key)
      newGroupHeights[key] = Math.max(newGroupHeights[key] || 0, $element.offsetHeight)
    })

    return newGroupHeights
  }

  /**
   * Gets the breakpoint of a particular match height group, below which the
   * elements' heights are set to "auto"
   *
   */
  static getBreakpoint = key => {
    const hasBreakpoint = Object.keys(BREAKPOINTS).some(breakpoint =>
      key.startsWith(`${breakpoint}:`)
    )

    return hasBreakpoint ? BREAKPOINTS[key.substring(0, 2)] : null
  }

  /**
   * Groups elements according to their match height group
   *
   */
  static groupElements = ({ groupHeights }) =>
    Object.keys(groupHeights).reduce(
      (acc, key) => ({
        ...acc,
        [key]: $$(`[data-match-height-row='${key}']`),
      }),
      {}
    )

  /**
   * Initialise the equal height calculation
   *
   */
  static initEqualHeight = $$matchHeightElements => {
    const groupHeights = this.calculateGroupHeights({ $$matchHeightElements })
    const elementGroups = this.groupElements({ groupHeights })
    this.matchHeights({ elementGroups, groupHeights })
  }

  /**
   * Matches the heights of elements
   *
   */
  static matchHeights = ({ elementGroups, groupHeights }) => {
    const groupHeightsMax = Object.keys(groupHeights).map(key => ({
      breakpoint: this.getBreakpoint(key),
      name: key,
      value: groupHeights[key],
    }))

    groupHeightsMax.forEach(({ breakpoint, name, value }) => {
      if (!elementGroups[name]) return
      elementGroups[name].forEach($element => {
        if (breakpoint && window.innerWidth < breakpoint) {
          $element.style.height = 'auto'
        } else {
          $element.style.height = `${value}px`
        }
      })
    })
  }

  static init = selector => {
    const $$matchHeightElements = $$(selector)
    if (!$$matchHeightElements) return

    this.initEqualHeight($$matchHeightElements)
    this.addResizeListeners($$matchHeightElements)
  }
}

window.addEventListener('load', async () => {
  await sleep(WAIT_THRESHOLD)

  MatchHeight.init('[data-match-height]')
})
